module.exports = __webpack_public_path__ + "a6b4ed1ed4303652b12fc534391a1a9a.pdf";